import { useNavigate } from "react-router";
import { G_ADMIN_USER } from "../../config/PermissionTypes";
import { isFeatureDisabled, lookUpFeatureFlagPermissions } from "../../util/FeatureFlagUtility";
import { useCompanyPermission, useCompanyFeatureFlag } from "../CompanySelection/CompanyContext";

export default function Has(props) {
    const userPermissions = useCompanyPermission();
    const flags = useCompanyFeatureFlag();
    const requiredPermissions = props.permission;
    const requiredFeatureFlags = props.featureFlag;
    const isPageLevelFlag = props.isPageLevel;

    function _isUnauthorized(isFeatureFlagCheck, isPermissionCheck){
        const navigate = useNavigate();

        if (isPageLevelFlag === true) {
            if (isFeatureFlagCheck && isPermissionCheck) {
                if(flags && userPermissions){
                    return navigate("/unauthorizedUser");
                }
            } else if (isFeatureFlagCheck) {
                if (flags) {
                    return navigate("/unauthorizedUser");
                }
            } else if (isPermissionCheck) {
                if (userPermissions) {
                    return navigate("/unauthorizedUser");
                }
            }
        }

        return <></>;
    }

    // if superuser, immediately provide access
    if (userPermissions?.includes(G_ADMIN_USER)) {
        return props.children;
    }

    // check if a feature flag is disabled 
    if (isFeatureDisabled(requiredFeatureFlags, flags)) {
        return _isUnauthorized(true, false);
    }

    // if a required permission is present ensure user has one of the permissions required 
    // in the list of granted permissions
    if (typeof requiredPermissions !== 'undefined' && requiredPermissions !== null) {
        let requiredPermissionsList = [];
        if(typeof requiredPermissions == 'string'){
            requiredPermissionsList = requiredPermissions.split(',');
        } else {
            requiredPermissionsList = requiredPermissions;
        }
        //Remove permissions from user if Feature flag to that permission is turned off
        if(userPermissions) {
            for (let index in requiredFeatureFlags) {
                let featureFlag = requiredFeatureFlags[index].trim()
                if(isFeatureDisabled(featureFlag, flags)){
                    //remove permissions from user set before checking if user has access
                    const featurePermissions = lookUpFeatureFlagPermissions(featureFlag);
                    for(let featurePermission in featurePermissions){
                        let permission = featurePermissions[featurePermission].trim()
                        const index = userPermissions.indexOf(permission);
                        if(index !== -1){
                            userPermissions.splice(index, 1);
                        }
                    }
                }
            }
        }
        for (let index in requiredPermissionsList) {
            let permission = requiredPermissionsList[index].trim()
            if (userPermissions?.find(singlePermission =>
                permission === singlePermission)) {
                return props.children;
            }
        }
        // didn't find a positive permission
        return _isUnauthorized(true, true);
    }
    
    // if not disabled or no features or permissions present
    return props.children;
}